module.exports = __webpack_public_path__ + "img/general-look.c706299f.svg";